export default __webpack_public_path__ + "static/media/google.e41057dd.png";